module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/$.iter-step.js
// module id = 66
// module chunks = 0